export default {"src":"/_next/static/media/swipe-arrow-indicator.92bf6257.svg","height":30,"width":64,"blurWidth":0,"blurHeight":0};